// Below is to allow dynamic selection of ancillary price type for forecasting.
// Previously these were hardcoded in the forecast inputs as Primary, Secondary and Tertiary
// However, this approach is not scalable, as ERCOT has five ancillary types.
// This logic automatically migrates legacy ancillarySettings for markets we
// have information on, currently only ERCOT.
// If there is no information on ancillary types for a specific market, no migration is done.

export const LEGACY_ANCILLARY_LABELS = ["primary", "secondary", "tertiary"];

// Legacy Ancillary types dictionary
// Primary, Secondary, Tertiary
export const LEGACY_ANCILLARY_SELECTION = {
  ERCOT: ["reg_up", "non_spin", "rrs"],
};

// Display labels for the canonical ancillary price types, per market.
// Used to render {text, value} items for ancillary type selectors.
export const ANCILLARY_PRODUCT_LABELS = {
  ERCOT: [
    { text: "Regulation Up", value: "reg_up" },
    { text: "Non Spin", value: "non_spin" },
    { text: "Responsive Reserve Service (RRS)", value: "rrs" },
    { text: "Regulation Down", value: "reg_down" },
    { text: "ECRS", value: "ecrs" },
  ],
};

export function isLegacyAncillaryLabels(labels) {
  return JSON.stringify(labels) === JSON.stringify(LEGACY_ANCILLARY_LABELS);
}

// Mutates ancillarySettings.ancillary_price_labels in place when a migration applies.
// Returns true if a migration was applied.
export function migrateLegacyAncillaryLabels(marketName, ancillarySettings) {
  const canonicalEquivalent = LEGACY_ANCILLARY_SELECTION[marketName];
  if (
    ancillarySettings.active &&
    canonicalEquivalent &&
    isLegacyAncillaryLabels(ancillarySettings.ancillary_price_labels)
  ) {
    ancillarySettings.ancillary_price_labels = [...canonicalEquivalent];
    return true;
  }
  return false;
}
